<template>
  <div class="modal-detalhes">
    <v-dialog :value="show" @input="fechar" width="800">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <p class="title">Detalhes do Auto</p>
          <p class="title">Auto: {{ item.numero_auto }}</p>
        </v-card-title>
        
        <v-card-text>
          <tabela-dados-auto :auto="[item.auto]" />
        </v-card-text>

        <v-card-text>
          <p><strong>Nr. do processo (SPU)</strong>: {{ item.cod_processo }}</p>
          <p><strong>Status do processo</strong>: {{ item.status_processo }}</p>
          <p><strong>Nome do Requerente:</strong> {{ item.requerente }} </p>
          <p><strong>Entrada do Protocolo:</strong> {{ item.data_protocolo | data }}</p>
          
          <p v-show="item.auto.julgador_defesa.data_auto.processos[0].justificativa">
            <strong>Justificativa Julgamento:</strong>
            <p>{{ item.auto.julgador_defesa.data_auto.processos[0].justificativa }}</p>
          </p>

          <p v-if="showJulgador"><hr></p>
          <p v-if="showJulgador"><strong>Alterado por:</strong> {{ justificativa(item.auto).julgador }}</p>
          <p v-if="showJustificativa"><strong>Justificativa:</strong>
            {{ justificativa(item.auto).justificativa | limiteCaracteres(90) }}

            <a
              v-if="justificativa(item.auto).justificativa.length > 90"
              @click="mostraModal">Ver mais</a>
          </p>
        </v-card-text>
        
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <template>
            <v-btn
              v-if="isRetornarProcesso(item.status_processo)"
              color="success"
              v-confirm="{
                ok: (dialog) => retornarProcesso(),
                message: 'Deseja retornar esse processo à análise?',
              }"
            >Retornar Análise</v-btn>

            <v-btn
              v-show="intepestivoButton && !isRetornarProcesso(item.status_processo)"
              color="warning"
              @click="requestAction('intempestivo')"
            >Intempestivo</v-btn>

            <v-btn
              v-if="!isRetornarProcesso(item.status_processo)"
              color="success"
              v-confirm="{
                ok: (dialog) => requestAction('deferido'),
                message: 'Deseja Deferir o Processo?',
              }"
            >Deferir</v-btn>
            
            <v-btn
              v-if="!isRetornarProcesso(item.status_processo)"
              color="red"
              dark
              v-confirm="{
                ok: (dialog) => requestAction('indeferido'),
                message: 'Deseja Indeferir o Processo?',
              }"
            >Indeferir</v-btn>

            <v-btn
              v-if="habilitarBtnDesfazerDefesa(item.id_status_auto, usuarioId)"
              color="warning"
              v-confirm="{
                ok: (dialog) => requisicaoDesfazerDefesa(item.auto.id_auto, item.id_status_auto),
                message: 'Deseja desfazer a defesa para esse auto?',
              }"
            >Desfazer Defesa</v-btn>
            
            <v-btn
              v-if="permissaoEditar"
              color="primary"
              @click="editar"
            >Editar</v-btn>
          </template>
          <v-btn color="default" @click="fechar">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable :value="mostrar_justificativa" @input="fechaModal" width="600">
      <v-card height="35vh">
        <v-card-title>
            <p>Justificativa de Defesa</p>
        </v-card-title>

        <v-card-text>
          <p><strong>{{ justificativa(item.auto).justificativa }}</strong></p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import TabelaDadosAuto from "@/components/TabelaDadosAuto";

export default {
  name: "ModalDetalhesRecuso",
  props: {
    item: {
      type: Object,
      required: true,
    },
    usuarioId: {
      type: Number,
      required: true
    },
    show: {
      type: Boolean,
      default: false,
    },
    showActionsButtons: {
      type: Boolean,
      default: false,
    },
    intepestivoButton: {
      type: Boolean,
      default: false,
    },
    permissaoEditar: {
      type: Boolean,
      default: false,
    },
    permissaoDeferir: {
      type: Boolean,
      default: false,
    },
    permissaoIndeferir: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      auto: {},
      showJustificativa: true,
      showJulgador: true,
      mostrar_justificativa: false
    };
  },
  components: { TabelaDadosAuto },
  methods: {
    fechar() {
      this.$emit("fechar");
    },
    requestAction(acao) {
      this.$emit("request-action", acao);
    },
    editar() {
      this.$emit("editar", { ...this.item });
    },
    isRetornarProcesso(status) {
      return ["deferido", "indeferido"].includes(status);
    },
    retornarProcesso() {
      this.$emit("retornar-processo");
    },
    justificativa(data) {
      const julgador_defesa = data.julgador_defesa.data_auto.julgador_defesa[0];

      const verificar_justificativa = julgador_defesa ? julgador_defesa.justificativa : false;
      const verificar_usuario = julgador_defesa ? julgador_defesa.user : false;

      const justificativa = verificar_justificativa || false;
      this.showJustificativa = justificativa == false ? false : true;
      
      const usuario = verificar_usuario instanceof Object ? verificar_usuario.name : false;
      this.showJulgador = usuario == false ? false : true;
      
      const result = {'justificativa': justificativa || '---', 'julgador': usuario || '---'};

      return result;
    },
    mostraModal() {
      this.mostrar_justificativa = true;
    },
    fechaModal() {
      this.mostrar_justificativa = false;
    },
    habilitarBtnDesfazerDefesa(id_status_auto, usuario_id) {
      const usuarios_permitidos = [13, 36, 1742];

      // OPERAÇÃO O 18 - Aguardando Envio, OPERAÇÃO A 18 - Aguardando Envio
      const status_auto_permitidos = [114, 168];

      return usuarios_permitidos.includes(usuario_id) && status_auto_permitidos.includes(id_status_auto);
    },
    requisicaoDesfazerDefesa(id_auto, id_status_auto) {
      this.$emit("requisicao-desfazer-defesa", {id_auto, id_status_auto});
    }
  },
  computed: {
    habilitarEdicaoComputed() {
      return this.item.deferido === null;
    },
  },
};
</script>

<style lang="scss">
  .dg-btn--cancel {
    color: #5ba39e;
    background-color: #fefefe;
    border-color: #5ba39e;
  }

  .dg-btn--ok {
    color: #fefefe;
    background-color: #5ba39e;
    border-color: #fefefe;
  }
</style>
